<template>
	<div class="member-info">
		<div style="clear: both;display: flex;justify-content: space-between;">
			<div class="case-pice">
				<span class="case-pice-first">会员单位管理</span>
				<span class="case-pice-and"> / </span>
				<span class="case-pice-second">{{nowPageType}}</span>
			</div>
			<div style="text-align: right;">
				<el-button size='small' type="primary" @click='saveMemberData()' plain>保存</el-button>
				<el-button size='small' type="info" @click='goBack()' plain>返回</el-button>
			</div>

		</div>
		<div style="height: calc(100vh - 130px);border: 1px solid #eee;border-radius: 4px;margin-top: 10px;overflow-y:auto ;overflow-x: hidden;">
			<div style="margin: 0 auto;width: 850px;">
				<div class="common-margin-10">
					<div class="commom-input-label-long xin">会员单位名称：</div>
					<el-input v-model="searchData.companyName" class='common-input-long-width' size='small' placeholder="请输入会员单位名称"></el-input>
					<div class="commom-input-label-long xin" style="margin-left: 20px;">统一社会代码：</div>
					<el-input v-model="searchData.creditCode" class='common-input-long-width' size='small' placeholder="请输入统一社会代码"></el-input>
				</div>
				<div>
					<div class="commom-input-label-long xin">所属区县：</div>
					<el-cascader class='common-input-long-width' size='small' :options="options" v-model="pullAddress" @change="handleChange" :props="setProps" clearable></el-cascader>
					<div class="commom-input-label-long xin" style="margin-left: 20px;">法人：</div>
					<el-input v-model="searchData.corp" class='common-input-long-width' size='small' placeholder="请输入法人名称"></el-input>
				</div>
				<div class="common-margin-10">
					<div class="commom-input-label-long xin">营业执照地址：</div>
					<el-input type="textarea" style='width: 680px;font-family: "微软雅黑"' :autosize='false' size='small' :rows="2" placeholder="请输入营业执照地址" v-model="searchData.businessAddress">
					</el-input>
				</div>
				<div style="clear: both;display: flex;margin: 20px 0 10px;">
					<div class="commom-input-label-long xin" style="height: 140px;line-height: 140px;float: left;">营业执照：</div>
					<div style="flex: 1;">
						<div class="img-block">
							<i v-if="yingyeFileList.length!=0" class="el-icon-circle-close img-close-icon" @click="deleteImg('yingye')"></i>
							<img :src="yingyeFileList[0]" alt="" id="yingye-view" />
						</div>
						<el-upload :before-upload="beforeAvatarUpload" :http-request="httpRequest" action='' :show-file-list='false'>
							<el-button size="small" type="primary">点击上传</el-button>
						</el-upload>
					</div>
				</div>
				<div style="clear: both;display: flex;margin: 10px 0;">
					<div class="commom-input-label-long xin" style="height: 140px;line-height: 140px;float: left;">会员申请表：</div>
					<div style="flex: 1;">
						<div class="img-block">
							<i v-if="memberFileList.length!=0" class="el-icon-circle-close img-close-icon" @click="deleteImg('member')"></i>
							<img :src="memberFileList[0]" alt="" id="member-view" />
						</div>
						<el-upload :before-upload="beforeAvatarUpload" :http-request="httpMemberRequest" action='' :show-file-list='false'>
							<el-button size="small" type="primary" class='upload-button'>点击上传</el-button>
						</el-upload>
					</div>
				</div>
				<div style="clear: both;display: flex;margin: 10px 0;">
					<div class="commom-input-label-long xin" style="height: 140px;line-height: 140px;float: left;">道路运输许可：</div>
					<div style="flex: 1;">
						<div class="img-block">
							<i v-if="roadFileList.length!=0" class="el-icon-circle-close img-close-icon" @click="deleteImg('road')"></i>
							<!--<img :src=""/>-->
							<img :src="roadFileList[0]" alt="" id="road-view" />
						</div>
						<el-upload :before-upload="beforeAvatarUpload" :http-request="httpRoadRequest" action='' :show-file-list='false'>
							<el-button size="small" type="primary">点击上传</el-button>
						</el-upload>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Viewer from 'viewerjs';
	import { addCompany, getDetailCompany } from '../../api/main'
	import mapjson from '../../common/js/map'
	import pageone from '../../assets/logo.png'
	export default {
		data() {
			return {
				nowPageType: '',
				pullAddress: [],
				searchData: {
					companyName: '',
					creditCode: '',
					businessAddress: '',
					corp:''
				},
				options: mapjson,
				setProps: {
					expandTrigger: 'click',
				},
				dialogYingyeImageUrl: '',
				dialogYingyeVisible: false,
				yingyeFileList: [],
				dialogMemberImageUrl: '',
				dialogMemberVisible: false,
				memberFileList: [],
				dialogRoadImageUrl: '',
				dialogRoadVisible: false,
				roadFileList: [],
				srcList: []
			}
		},
		methods: {
			deleteImg(text) {
				if(text == 'yingye') {
					this.yingyeFileList = [];
				} else if(text == 'member') {
					this.memberFileList = [];
				} else {
					this.roadFileList = [];
				}
			},
			httpRoadRequest(options) {
				var that = this
				// 获取文件对象
				let file = options.file
				//判断图片类型
				if(file.type == 'image/jpeg' || file.type == 'image/png' || file.type == 'image/JPG') {
					var isJPG = true
				} else {
					isJPG = false
				}
				const isLt2M = file.size / 1024 / 1024 < 0.2
				if(!isJPG) {
					this.$message.error('上传产品图片只能是 JPG/PNG/JPEG 格式!')
				}
				// if(!isLt2M) {
				// 	this.$message.error('照片过大，请将图片大小压缩至200kb以下')
				// }
				var reader = new FileReader();
				//创建一个img对象
				var img = new Image();
				let filename = options.filename
				if(file) {
					reader.readAsDataURL(file)
				}
				if(isJPG) {
					reader.onload = (e) => {
						let base64Str = reader.result.split(',')[1]
						console.log(base64Str)
						img.src = e.target.result
						// base64地址图片加载完毕后执行
						img.onload = function() {
							// 缩放图片需要的canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
							var canvas = document.createElement('canvas');
							var context = canvas.getContext('2d');
							// 图片原始尺寸
							var originWidth = this.width;
							var originHeight = this.height;
							// 最大尺寸限制，可通过设置宽高来实现图片压缩程度
							var maxWidth = 300,
								maxHeight = 300;
							// 目标尺寸
							var targetWidth = originWidth,
								targetHeight = originHeight;
							// 图片尺寸超过最大尺寸的限制
							if(originWidth > maxWidth || originHeight > maxHeight) {
								if(originWidth / originHeight > maxWidth / maxHeight) {
									// 更改宽度，按照宽度限定尺寸
									targetWidth = maxWidth;
									targetHeight = Math.round(maxWidth * (originHeight / originWidth));
								} else {
									targetHeight = maxHeight;
									targetWidth = Math.round(maxHeight * (originWidth / originHeight));
								}
							}
							//对图片进行缩放
							canvas.width = targetWidth;
							canvas.height = targetHeight;
							// 清除画布
							context.clearRect(0, 0, targetWidth, targetHeight);
							// 图片压缩
							context.drawImage(img, 0, 0, targetWidth, targetHeight);
							/*第一个参数是创建的img对象；第二三个参数是左上角坐标，后面两个是画布区域宽高*/
							//压缩后的base64文件
							var newUrl = canvas.toDataURL('image/jpeg', 0.92);
							that.roadFileList.unshift(newUrl);
							const viewer = new Viewer(document.getElementById('road-view'), {
								// 相关配置项,详情见下面
							})
						}
					}
				}
			},
			httpMemberRequest(options) {
				var that = this
				// 获取文件对象
				let file = options.file
				//判断图片类型
				if(file.type == 'image/jpeg' || file.type == 'image/png' || file.type == 'image/JPG') {
					var isJPG = true
				} else {
					isJPG = false
				}
				const isLt2M = file.size / 1024 / 1024 < 0.2
				if(!isJPG) {
					this.$message.error('上传产品图片只能是 JPG/PNG/JPEG 格式!')
				}
				// if(!isLt2M) {
				// 	this.$message.error('照片过大，请将图片大小压缩至200kb以下')
				// }
				var reader = new FileReader();
				//创建一个img对象
				var img = new Image();
				let filename = options.filename
				if(file) {
					reader.readAsDataURL(file)
				}
				if(isJPG) {
					reader.onload = (e) => {
						let base64Str = reader.result.split(',')[1]
						console.log(base64Str)
						img.src = e.target.result
						// base64地址图片加载完毕后执行
						img.onload = function() {
							// 缩放图片需要的canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
							var canvas = document.createElement('canvas');
							var context = canvas.getContext('2d');
							// 图片原始尺寸
							var originWidth = this.width;
							var originHeight = this.height;
							// 最大尺寸限制，可通过设置宽高来实现图片压缩程度
							var maxWidth = 300,
								maxHeight = 300;
							// 目标尺寸
							var targetWidth = originWidth,
								targetHeight = originHeight;
							// 图片尺寸超过最大尺寸的限制
							if(originWidth > maxWidth || originHeight > maxHeight) {
								if(originWidth / originHeight > maxWidth / maxHeight) {
									// 更改宽度，按照宽度限定尺寸
									targetWidth = maxWidth;
									targetHeight = Math.round(maxWidth * (originHeight / originWidth));
								} else {
									targetHeight = maxHeight;
									targetWidth = Math.round(maxHeight * (originWidth / originHeight));
								}
							}
							//对图片进行缩放
							canvas.width = targetWidth;
							canvas.height = targetHeight;
							// 清除画布
							context.clearRect(0, 0, targetWidth, targetHeight);
							// 图片压缩
							context.drawImage(img, 0, 0, targetWidth, targetHeight);
							/*第一个参数是创建的img对象；第二三个参数是左上角坐标，后面两个是画布区域宽高*/
							//压缩后的base64文件
							var newUrl = canvas.toDataURL('image/jpeg', 0.92);
							console.log(newUrl)
							that.memberFileList.unshift(newUrl);
							const viewer = new Viewer(document.getElementById('member-view'), {
								// 相关配置项,详情见下面
							})
						}
					}
				}
			},
			httpRequest(options) {
				var that = this
				// 获取文件对象
				let file = options.file
				//判断图片类型
				if(file.type == 'image/jpeg' || file.type == 'image/png' || file.type == 'image/JPG') {
					var isJPG = true
				} else {
					isJPG = false
				}
				const isLt2M = file.size / 1024 / 1024 < 0.2
				if(!isJPG) {
					this.$message.error('上传产品图片只能是 JPG/PNG/JPEG 格式!')
				}
				// if(!isLt2M) {
				// 	this.$message.error('照片过大，请将图片大小压缩至200kb以下')
				// }
				var reader = new FileReader();
				//创建一个img对象
				var img = new Image();
				let filename = options.filename
				if(file) {
					reader.readAsDataURL(file)
				}
				if(isJPG) {
					reader.onload = (e) => {
						let base64Str = reader.result.split(',')[1]
						console.log(base64Str)
						img.src = e.target.result
						// base64地址图片加载完毕后执行
						img.onload = function() {
							// 缩放图片需要的canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
							var canvas = document.createElement('canvas');
							var context = canvas.getContext('2d');
							// 图片原始尺寸
							var originWidth = this.width;
							var originHeight = this.height;
							// 最大尺寸限制，可通过设置宽高来实现图片压缩程度
							var maxWidth = 300,
								maxHeight = 300;
							// 目标尺寸
							var targetWidth = originWidth,
								targetHeight = originHeight;
							// 图片尺寸超过最大尺寸的限制
							if(originWidth > maxWidth || originHeight > maxHeight) {
								if(originWidth / originHeight > maxWidth / maxHeight) {
									// 更改宽度，按照宽度限定尺寸
									targetWidth = maxWidth;
									targetHeight = Math.round(maxWidth * (originHeight / originWidth));
								} else {
									targetHeight = maxHeight;
									targetWidth = Math.round(maxHeight * (originWidth / originHeight));
								}
							}
							//对图片进行缩放
							canvas.width = targetWidth;
							canvas.height = targetHeight;
							// 清除画布
							context.clearRect(0, 0, targetWidth, targetHeight);
							// 图片压缩
							context.drawImage(img, 0, 0, targetWidth, targetHeight);
							/*第一个参数是创建的img对象；第二三个参数是左上角坐标，后面两个是画布区域宽高*/
							//压缩后的base64文件
							var newUrl = canvas.toDataURL('image/jpeg', 0.92);
							console.log(newUrl)
							that.yingyeFileList.unshift(newUrl)

							const viewer = new Viewer(document.getElementById('yingye-view'), {
								// 相关配置项,详情见下面
							})
						}
					}
				}
			},
			handleChange() {

			},
			//营业执照上传开始
			handleYingyeUploadChange(data) {
				console.log(this.yingyeFileList)
			},
			handleYingyeRemove(file, yingyeFileList) {
				console.log(file, yingyeFileList);
			},
			handleYingyePictureCardPreview(file) {
				this.dialogYingyeImageUrl = file.url;
				this.dialogYingyeVisible = true;
			},
			//			//会员单位上传开始
			handleMemberRemove(file, fileList) {
				console.log(file, fileList);
			},
			handleMemberPictureCardPreview(file) {
				this.dialogMemberImageUrl = file.url;
				this.dialogMemberVisible = true;
			},
			//道路许可证上传开始
			handleRoadRemove(file, fileList) {
				console.log(file, fileList);
			},
			handleRoadPictureCardPreview(file) {
				this.dialogRoadImageUrl = file.url;
				this.dialogRoadVisible = true;
			},
			saveMemberData() {
				if(this.searchData.companyName == '') {
					this.$message.error('请输入单位名称');
					return;
				}
				if(this.searchData.creditCode == '') {
					this.$message.error('请输入统一社会代码');
					return;
				}
				if(this.searchData.corp == '') {
					this.$message.error('请输入法人姓名');
					return;
				}
				if(this.pullAddress.length == 0) {
					this.$message.error('请选择所属区县');
					return;
				}
				if(this.searchData.businessAddress == '') {
					this.$message.error('请输入营业执照地址');
					return;
				}
				if(this.yingyeFileList.length == 0) {
					this.$message.error('请上传营业执照');
					return;
				}
				if(this.memberFileList.length == 0) {
					this.$message.error('请上传会员申请表');
					return;
				}
				if(this.roadFileList.length == 0) {
					this.$message.error('请上传道路运输许可');
					return;
				}
				if(this.$store.state.memberPageType == 'add') {
					addCompany({
						businessAddress: this.searchData.businessAddress,
						companyName: this.searchData.companyName,
						creditCode: this.searchData.creditCode,
						provinceName: this.pullAddress[0],
						provinceCode: this.pullAddress[0],
						cityName: this.pullAddress[1],
						cityCode: this.pullAddress[1],
						countyName: this.pullAddress[2],
						countyCode: this.pullAddress[2],
						businessLicenseImg: this.yingyeFileList[0],
						vipFormImg: this.memberFileList[0],
						transportLicenseImg: this.roadFileList[0],
						corp:this.searchData.corp
					}).then(res => {
						if(res.code == 1) {
							this.$message.success('新增会员单位成功');
							this.$router.go(-1);
						} else {
							this.$message.error(res.msg);
						}
					})
				} else {
					let  data = {
						companyId: this.$store.state.memberPageId,
						businessAddress: this.searchData.businessAddress,
						companyName: this.searchData.companyName,
						creditCode: this.searchData.creditCode,
						provinceName: this.pullAddress[0],
						provinceCode: this.pullAddress[0],
						cityName: this.pullAddress[1],
						cityCode: this.pullAddress[1],
						countyName: this.pullAddress[2],
						countyCode: this.pullAddress[2],
						businessLicenseImg: this.yingyeFileList[0],
						vipFormImg: this.memberFileList[0],
						transportLicenseImg: this.roadFileList[0],
						corp:this.searchData.corp
					}
					console.log('----修改的数据');
					console.log(data);
					console.log('----修改的数据');
					
					addCompany({
						companyId: this.$store.state.memberPageId,
						businessAddress: this.searchData.businessAddress,
						companyName: this.searchData.companyName,
						creditCode: this.searchData.creditCode,
						provinceName: this.pullAddress[0],
						provinceCode: this.pullAddress[0],
						cityName: this.pullAddress[1],
						cityCode: this.pullAddress[1],
						countyName: this.pullAddress[2],
						countyCode: this.pullAddress[2],
						businessLicenseImg: this.yingyeFileList[0],
						vipFormImg: this.memberFileList[0],
						transportLicenseImg: this.roadFileList[0],
						corp:this.searchData.corp
					}).then(res => {
						if(res.code == 1) {
							this.$message.success('修改会员单位成功');
							this.$router.go(-1);
						} else {
							this.$message.error(res.msg);
						}
					})
				}

			},
			goBack() {
				this.$router.go(-1);
			},
			beforeAvatarUpload(file) {
				console.log(file)
				const isJPG = file.type;
				if(isJPG == 'image/jpeg' || isJPG == 'image/png') {
					return isJPG;
				} else {
					this.$message.error('上传头像图片只能是JPG或者PNG格式!');
				}
				return false;
			}
		},
		mounted() {
			if(this.$store.state.memberPageType == 'add') {
				this.nowPageType = '添加会员单位'
			} else if(this.$store.state.memberPageType == 'update') {
				this.nowPageType = '修改会员单位'
				getDetailCompany(this.$store.state.memberPageId).then(res => {
					this.searchData.companyName = res.data.companyName;
					this.searchData.businessAddress = res.data.businessAddress;
					this.searchData.creditCode = res.data.creditCode;
					this.searchData.corp = res.data.corp;
					this.pullAddress = [res.data.provinceName, res.data.cityName, res.data.countyName],
						this.yingyeFileList.unshift(res.data.businessLicenseImg);
					this.memberFileList.unshift(res.data.vipFormImg);
					this.roadFileList.unshift(res.data.transportLicenseImg);
					const viewer = new Viewer(document.getElementById('yingye-view'), {
						// 相关配置项,详情见下面
					})
					const viewer1 = new Viewer(document.getElementById('member-view'), {
						// 相关配置项,详情见下面
					})
					const viewer2 = new Viewer(document.getElementById('road-view'), {
						// 相关配置项,详情见下面
					})
				})
			} else {
				this.nowPageType = '查看会员单位'
			}
		}
	}
</script>

<style lang="less">
	.member-info {}
	
	.img-block {
		height: 150px;
		width: 150px;
		display: inline-block;
		border-radius: 10px;
		border: 1px solid #ccc;
		margin-bottom: 10px;
		position: relative;
	}
	
	.img-close-icon {
		position: absolute;
		top: 5px;
		right: 5px;
		z-index: 10;
		font-size: 20px;
		color: #EEEEEE;
		font-weight: bold;
		cursor: pointer;
	}
	
	.img-block img {
		border-radius: 10px;
		cursor: pointer;
		width: 100%;
		height: 100%;
	}
	
	.img-block .el-upload {
		margin: 10px 31px 0 0;
	}
</style>